import React from 'react';

import { locale } from '@trqk/utils';

import { AccountAvatar } from '.';

import './account-header-content.css';

import soundWavesImg from '../../../../../assets/svg/sound_waves_wide_3500w_opacity_25.svg';

interface AccountHeaderContentProps {
    currentUser: User | null;
}

/**
 * Content for use in the LeftNavHeader for the Account page.
 * @param props {AccountHeaderContentProps}
 */
export const AccountHeaderContent = ({
    currentUser,
}: AccountHeaderContentProps): JSX.Element => {
    const userId = currentUser?.id ?? null;

    return (
        <div className="flex items-center absolute">
            <img
                alt={locale.enUS.ACCOUNT.HEADER.IMG_ALT}
                src={soundWavesImg}
                className="fixed w-screen object-cover"
                style={{
                    top: -200,
                    left: 0,
                    zIndex: -10,
                }}
            />
            <div
                className="relative flex-none"
                style={{
                    top: -213,
                    left: 54,
                }}
            >
                {userId !== null && <AccountAvatar userId={userId} />}
            </div>
        </div>
    );
};
